// import OwlCarousel from "react-owl-carousel";
// import "owl.carousel/dist/assets/owl.carousel.css";
// import "owl.carousel/dist/assets/owl.theme.default.css";

function App() {
  return (
    <>
      <header id="header" class="tra-menu navbar-light white-scroll">
        <div class="header-wrapper">
          <div class="wsmobileheader clearfix">
            <span class="smllogo">
              <a href="#hero-1">
                <img
                  class="lt-img"
                  src="assets/images/logo.png"
                  alt="mobile-logo"
                />
                <img
                  class="dt-img"
                  src="assets/images/logo-white.png"
                  alt="mobile-logo"
                />
              </a>
            </span>
            <a id="wsnavtoggle" class="wsanimated-arrow">
              <span></span>
            </a>
          </div>

          <div class="wsmainfull menu clearfix">
            <div class="wsmainwp clearfix">
              <div class="desktoplogo">
                <a href="#hero-1" class="logo-black">
                  <img
                    class="lt-img"
                    src="assets/images/app_logo.png"
                    alt="logo"
                  />
                  <img
                    class="dt-img"
                    src="assets/images/app_logo.png"
                    alt="logo"
                  />
                </a>
              </div>

              <div class="desktoplogo">
                <a href="#hero-1" class="logo-white">
                  <img src="assets/images/app_logo.png" alt="logo" />
                </a>
              </div>
              <nav class="wsmenu clearfix">
                <ul class="wsmenu-list nav-theme">
                  <li aria-haspopup="true">
                    <a href="#" class="h-link">
                      About
                    </a>
                  </li>

                  <li class="nl-simple mobile-last-link" aria-haspopup="true">
                    <a
                      href="#download"
                      class="btn r-36 ico-20 ico-right btn--tra-white hover--theme last-link"
                    >
                      Download <span class="flaticon-download-file"></span>
                    </a>
                  </li>
                </ul>
              </nav>
            </div>
          </div>
        </div>
      </header>

      <section id="hero-1" class="bg--fixed hero-section division">
        <div class="container">
          <div class="row d-flex align-items-center">
            <div class="col-md-6">
              <div class="hero-1-txt color--white wow animate__animated animate__fadeInRight">
                <h2>
                  Turn your ideas into reality with the support of your network.
                </h2>

                <p class="p-lg">
                  Share your ideas, connect with supporters, and bring your
                  vision to life—all in one platform.
                </p>

                <div class="stores-badge badge-img-md">
                  <a href="#" class="store">
                    <img
                      class="appstore"
                      src="assets/images/store_badges/appstore.png"
                      alt="appstore-badge"
                    />
                  </a>

                  <a href="#" class="store">
                    <img
                      class="googleplay"
                      src="assets/images/store_badges/googleplay.png"
                      alt="googleplay-badge"
                    />
                  </a>
                </div>
                <div class="os-version-ext">
                  <div class="star-rating clearfix ico-10">
                    <span class="flaticon-star color--yellow"></span>
                    <span class="flaticon-star color--yellow"></span>
                    <span class="flaticon-star color--yellow"></span>
                    <span class="flaticon-star color--yellow"></span>
                    <span class="flaticon-star-half-empty color--yellow"></span>
                    <small>4,78K+ Ideateller users reviews.</small>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-md-6">
              <div class="hero-1-img wow animate__animated animate__fadeInLeft">
                <img
                  class="img-fluid"
                  src="assets/images/hero-1-img.png"
                  alt="hero-image"
                />
              </div>
            </div>
          </div>
        </div>
      </section>

      <section class="py-100 features-1 features-section division">
        <div class="container">
          <div class="row justify-content-center">
            <div class="col-md-10 col-lg-9">
              <div class="section-title text-center mb-80">
                <h2 class="h2-xl">Everything in One Place</h2>
                <p class="p-lg">
                  Raise funds, build support, and communicate—all in one place.
                </p>
              </div>
            </div>
          </div>

          <div class="fbox-wrapper text-center">
            <div class="row row-cols-1 row-cols-md-2 row-cols-lg-4">
              <div class="col">
                <div class="fbox-1 fb-1 wow animate__animated animate__fadeInUp animate__delay-1">
                  <div class="fbox-ico ico-60">
                    <div class="shape-ico color--theme-2">
                      <span class="flaticon-alter"></span>
                      <svg
                        viewBox="0 0 200 200"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M66.1,-32.6C77.9,-17.7,74.4,11.6,60.8,35.7C47.2,59.7,23.6,78.5,2.8,76.9C-18,75.2,-35.9,53.2,-47.7,30.1C-59.5,7.1,-65.1,-16.9,-56.1,-30.1C-47.1,-43.4,-23.6,-46,1.8,-47C27.2,-48.1,54.3,-47.6,66.1,-32.6Z"
                          transform="translate(100 100)"
                        />
                      </svg>
                    </div>
                  </div>
                  <div class="fbox-txt">
                    <h6 class="h6-lg">Private Event</h6>
                    <p>
                      Personal Fundraising Made Simple. Raise funds for personal
                      events like birthdays or passion projects. Share photos
                      and videos to inspire support.
                    </p>
                  </div>
                </div>
              </div>
              <div class="col">
                <div class="fbox-1 fb-2 wow animate__animated animate__fadeInUp animate__delay-2">
                  <div class="fbox-ico ico-60">
                    <div class="shape-ico color--theme-2">
                      <span class="flaticon-color-palette"></span>
                      <svg
                        viewBox="0 0 200 200"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M66.1,-32.6C77.9,-17.7,74.4,11.6,60.8,35.7C47.2,59.7,23.6,78.5,2.8,76.9C-18,75.2,-35.9,53.2,-47.7,30.1C-59.5,7.1,-65.1,-16.9,-56.1,-30.1C-47.1,-43.4,-23.6,-46,1.8,-47C27.2,-48.1,54.3,-47.6,66.1,-32.6Z"
                          transform="translate(100 100)"
                        />
                      </svg>
                    </div>
                  </div>
                  <div class="fbox-txt">
                    <h6 class="h6-lg">Community Event</h6>
                    <p>
                      Support Community Causes. Come together to make a
                      difference—raise funds for community projects like road
                      repairs or local improvements.
                    </p>
                  </div>
                </div>
              </div>
              <div class="col">
                <div class="fbox-1 fb-3 wow animate__animated animate__fadeInUp animate__delay-3">
                  <div class="fbox-ico ico-60">
                    <div class="shape-ico color--theme-2">
                      <span class="flaticon-union"></span>

                      <svg
                        viewBox="0 0 200 200"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M66.1,-32.6C77.9,-17.7,74.4,11.6,60.8,35.7C47.2,59.7,23.6,78.5,2.8,76.9C-18,75.2,-35.9,53.2,-47.7,30.1C-59.5,7.1,-65.1,-16.9,-56.1,-30.1C-47.1,-43.4,-23.6,-46,1.8,-47C27.2,-48.1,54.3,-47.6,66.1,-32.6Z"
                          transform="translate(100 100)"
                        />
                      </svg>
                    </div>
                  </div>

                  <div class="fbox-txt">
                    <h6 class="h6-lg">Career Development</h6>
                    <p>
                      Empower Your Career Journey. Launch fundraisers to propel
                      your career in fields like fashion, entertainment, and
                      more.
                    </p>
                  </div>
                </div>
              </div>

              <div class="col">
                <div class="fbox-1 fb-4 wow animate__animated animate__fadeInUp animate__delay-4">
                  <div class="fbox-ico ico-60">
                    <div class="shape-ico color--theme-2">
                      <span class="flaticon-smartphone"></span>

                      <svg
                        viewBox="0 0 200 200"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M66.1,-32.6C77.9,-17.7,74.4,11.6,60.8,35.7C47.2,59.7,23.6,78.5,2.8,76.9C-18,75.2,-35.9,53.2,-47.7,30.1C-59.5,7.1,-65.1,-16.9,-56.1,-30.1C-47.1,-43.4,-23.6,-46,1.8,-47C27.2,-48.1,54.3,-47.6,66.1,-32.6Z"
                          transform="translate(100 100)"
                        />
                      </svg>
                    </div>
                  </div>
                  <div class="fbox-txt">
                    <h6 class="h6-lg">Seamless Communication</h6>
                    <p>
                      Stay Connected with Supporters. Chat, call, and video
                      conference with your supporters to keep them engaged and
                      informed.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <hr class="divider" />

      <section class="pt-100 ct-01 content-section division">
        <div class="container">
          <div class="row d-flex align-items-center">
            <div class="col-md-6">
              <div class="img-block left-column wow animate__animated animate__fadeInRight">
                <img
                  class="img-fluid"
                  src="assets/images/img-01.png"
                  alt="content-image"
                />
              </div>
            </div>

            <div class="col-md-6">
              <div class="txt-block right-column wow animate__animated animate__fadeInLeft">
                <h2 class="h2-md">Share Your Vision, Inspire Support</h2>
                <p>
                  With Ideateller, showcase your ideas and dreams through images
                  and videos, bringing your vision to life for friends, family,
                  and supporters. Whether it's a personal project, community
                  cause, or career milestone, share updates and inspire others
                  to join you on your journey.
                </p>
                <ul class="simple-list">
                  <li class="list-item">
                    <p>
                      Highlight your campaign with photos and videos to
                      captivate supporters.
                    </p>
                  </li>

                  <li class="list-item">
                    <p class="mb-0">
                      Share your progress and updates in real-time to keep
                      backers engaged.
                    </p>
                  </li>
                  <li class="list-item">
                    <p class="mb-0">
                      Build connections that go beyond funding through chat,
                      voice, and video calls.
                    </p>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section id="benefits" class="pt-100 ct-01 content-section division">
        <div class="container">
          <div class="row d-flex align-items-center">
            <div class="col-md-6 order-last order-md-2">
              <div class="txt-block left-column wow animate__animated animate__fadeInRight">
                <div class="txt-box">
                  <h5 class="h5-lg">Make Your Campaign Stand Out</h5>
                  <p>
                    With Ideateller, setting up and managing your fundraising
                    campaigns is simple and efficient. Customize your visuals,
                    showcase your ideas with impactful images and videos, and
                    save time with tools designed to help you focus on what
                    matters most—connecting with supporters.
                  </p>
                </div>
                <div class="txt-box">
                  <h5 class="h5-lg">
                    Personalized Tools and Real-Time Updates
                  </h5>

                  <p>
                    Ideateller gives you complete control over your campaign’s
                    look and feel. Easily adjust images, add updates, and export
                    key information to share progress with your network. Keep
                    your supporters engaged and inspired with every step
                    forward.
                  </p>
                  <ul class="simple-list">
                    <li class="list-item">
                      <p>
                        Customizable images and videos for a unique campaign
                        style.
                      </p>
                    </li>

                    <li class="list-item">
                      <p class="mb-0">
                        Effortless updates to keep backers informed and
                        connected.
                      </p>
                    </li>

                    <li class="list-item">
                      <p class="mb-0">
                        Export options to share your progress across multiple
                        channels.
                      </p>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
            <div class="col-md-6 order-first order-md-2">
              <div class="img-block right-column wow animate__animated animate__fadeInLeft">
                <img
                  class="img-fluid"
                  src="assets/images/img-06.png"
                  alt="content-image"
                />
              </div>
            </div>
          </div>
        </div>
      </section>

      <section id="features" class="pt-100 features-4 features-section">
        <div class="container">
          <div class="row justify-content-center">
            <div class="col-md-9 col-lg-8">
              <div class="section-title text-center mb-70">
                <h2 class="h2-xl">
                  Empower your ideas and raise funds effortlessly with smart
                  tools and seamless connections.
                </h2>
              </div>
            </div>
          </div>

          <div class="fbox-wrapper text-center">
            <div class="row d-flex align-items-center">
              <div class="col-md-6">
                <div class="fbox-4 fb-7 bg--03 r-24 wow animate__animated animate__fadeInUp animate__delay-1">
                  <div class="fbox-txt">
                    <h5 class="h5-lg">Group Photo Sharing</h5>
                    <p class="mb-0">
                      Lacinia quaerat ipsum congue in porttitor ipsum and cursus
                      placerat neque cursus mollis dapibus
                    </p>
                  </div>
                  <div class="fbox-4-img">
                    <img
                      class="img-fluid"
                      src="assets/images/sharing.png"
                      alt="feature-image"
                    />
                  </div>
                </div>
              </div>
              <div class="col-md-6">
                <div class="fbox-4 fb-8 bg--03 r-24 wow animate__animated animate__fadeInUp animate__delay-2">
                  <div class="fbox-txt">
                    <h5 class="h5-lg">Effective Communication</h5>
                    <p class="mb-0">
                      Quaerat ipsum lacinia congue in porttitor ipsum and cursus
                      placerat neque cursus magna gravida
                    </p>
                  </div>
                  <div class="fbox-4-img">
                    <img
                      class="img-fluid"
                      src="assets/images/messaging.png"
                      alt="feature-image"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section class="pt-30 features-4 features-section">
        <div class="container">
          <div class="fbox-4-wrapper bg--03 r-24 wow animate__animated animate__fadeInUp animate__delay-1">
            <div class="row d-flex align-items-center">
              <div class="col-md-6">
                <div class="fbox-4-txt right-column">
                  <h3 class="h3-lg">
                    Share your ideas, moments, and stories in real-time
                  </h3>

                  <p class="mb-0">
                    Bring your vision to life by sharing updates, photos, and
                    videos instantly with your supporters. Keep them engaged and
                    inspired every step of the way as you work together to make
                    a real impact. Connect, inspire, and watch your goals become
                    reality with every contribution and interaction.
                  </p>
                </div>
              </div>
              <div class="col-md-6">
                <div class="fbox-4-img left-column">
                  <img
                    class="img-fluid r-24"
                    src="assets/images/img-16.jpg"
                    alt="feature-image"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section class="py-100 ct-05 content-section division">
        <div class="container">
          <div class="row justify-content-center">
            <div class="col-md-8">
              <div class="section-title text-center mb-60">
                <h2 class="h2-xl">
                  Bring Your Dreams to Life. Share Your Journey Everywhere.
                </h2>
                <p class="p-lg">
                  Capture every milestone and share your progress with
                  supporters. From your first step to your goal, let others be a
                  part of your inspiring story.
                </p>
              </div>
            </div>
          </div>

          <div class="row">
            <div class="col">
              <div class="img-block wow animate__animated animate__fadeInUp">
                <img
                  class="img-fluid lt-img"
                  src="assets/images/img-21.png"
                  alt="content-image"
                />
                <img
                  class="img-fluid dt-img"
                  src="assets/images/img-21d.png"
                  alt="content-image"
                />
              </div>
            </div>
          </div>

          <div class="row">
            <div class="col">
              <div class="img-block-btn wow animate__animated animate__fadeInUp">
                <a
                  href="#download"
                  class="btn btn-md r-36 btn--theme hover--tra-black"
                >
                  Get started - it's free
                </a>
                <ul class="advantages ico-15 clearfix">
                  <li>
                    <p>
                      Start Your Journey for Free – No Trial, Just Full Access!
                    </p>
                  </li>
                  <li class="advantages-links-divider">
                    <p>
                      <span class="flaticon-minus-1"></span>
                    </p>
                  </li>
                  <li>
                    <p>Exclusive Support</p>
                  </li>
                  <li class="advantages-links-divider">
                    <p>
                      <span class="flaticon-minus-1"></span>
                    </p>
                  </li>
                  <li>
                    <p>No Fees</p>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </section>

      <hr class="divider" />

      <section class="pt-100 ct-01 content-section division">
        <div class="container">
          <div class="row d-flex align-items-center">
            <div class="col-md-6">
              <div class="img-block left-column wow animate__animated animate__fadeInRight">
                <img
                  class="img-fluid lt-img"
                  src="assets/images/img-08.png"
                  alt="content-image"
                />
                <img
                  class="img-fluid dt-img"
                  src="assets/images/img-08d.png"
                  alt="content-image"
                />
              </div>
            </div>

            <div class="col-md-6">
              <div class="txt-block right-column wow animate__animated animate__fadeInLeft">
                <h2 class="h2-md">Connect Anytime, Anywhere</h2>
                <p>
                  Share your story and gain support from anywhere in the world.
                  With real-time access to your campaign and supporters, stay
                  connected and engaged no matter where you are.
                </p>

                <div class="txt-box">
                  <h5 class="h5-lg">Boost Your Fundraising Potential</h5>

                  <ul class="simple-list">
                    <li class="list-item">
                      <p>
                        Easily connect with backers, share updates, and receive
                        contributions all in one place. Build momentum and bring
                        your ideas to life with a community of supporters by
                        your side.
                      </p>
                    </li>

                    <li class="list-item">
                      <p class="mb-0">
                        Simplify fundraising with tools that make connecting and
                        sharing your progress easy, efficient, and inspiring.
                      </p>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section
        id="how-it-works"
        class="pt-100 bc-03 ws-wrapper content-section"
      >
        <div class="container">
          <div class="bc-03-wrapper bg--03 hidd r-24">
            <div class="section-overlay">
              <div class="row justify-content-center">
                <div class="col-md-10 col-lg-9">
                  <div class="section-title text-center wow animate__animated animate__fadeInUp">
                    <h2 class="h2-lg">Easily Manage and Share Your Campaign</h2>

                    <p class="p-md">
                      Customize your content, update supporters, and showcase
                      your progress effortlessly. With simple tools at your
                      fingertips, keeping your campaign fresh and engaging has
                      never been easier.
                    </p>
                  </div>
                </div>
              </div>

              <div class="row justify-content-center">
                <div class="col">
                  <div class="bc-3-img video-preview wow animate__animated animate__fadeInUp">
                    <a
                      class="video-popup1"
                      href="https://www.youtube.com/embed/SZEflIVnhH8"
                    >
                      <div class="video-btn video-btn-xl bg--theme-2">
                        <div class="video-block-wrapper">
                          <span class="flaticon-play-button"></span>
                        </div>
                      </div>
                    </a>

                    <img
                      class="img-fluid"
                      src="assets/images/tablet-01.png"
                      alt="content-image"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section class="py-100 features-3 features-section division">
        <div class="container">
          <div class="row justify-content-center">
            <div class="col-md-9 col-lg-8">
              <div class="section-title text-center mb-70">
                <p class="p-xl mt-0">
                  Share updates, engage with supporters, and watch your campaign
                  grow. Every story, photo, and message strengthens your
                  journey, bringing you closer to reaching your goal.
                </p>
              </div>
            </div>
          </div>

          <div class="fbox-wrapper text-center">
            <div class="row row-cols-1 row-cols-md-2 row-cols-lg-4">
              <div class="col">
                <div class="fbox-3 fb-1 r-12 wow fadeInUp">
                  <div class="fbox-ico ico-55">
                    <div class="shape-ico color--theme-2">
                      <span class="flaticon-interface-1"></span>
                      <svg
                        viewBox="0 0 200 200"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M66.1,-32.6C77.9,-17.7,74.4,11.6,60.8,35.7C47.2,59.7,23.6,78.5,2.8,76.9C-18,75.2,-35.9,53.2,-47.7,30.1C-59.5,7.1,-65.1,-16.9,-56.1,-30.1C-47.1,-43.4,-23.6,-46,1.8,-47C27.2,-48.1,54.3,-47.6,66.1,-32.6Z"
                          transform="translate(100 100)"
                        />
                      </svg>
                    </div>
                  </div>
                  <div class="fbox-txt">
                    <h6 class="h6-lg">User-Friendly</h6>
                    <p class="p-sm">
                      Manage campaigns easily, focusing on sharing and
                      connecting with supporters.
                    </p>
                  </div>
                </div>
              </div>
              <div class="col">
                <div class="fbox-3 fb-2 r-12 wow fadeInUp">
                  <div class="fbox-ico ico-55">
                    <div class="shape-ico color--theme-2">
                      <span class="flaticon-prioritize"></span>
                      <svg
                        viewBox="0 0 200 200"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M66.1,-32.6C77.9,-17.7,74.4,11.6,60.8,35.7C47.2,59.7,23.6,78.5,2.8,76.9C-18,75.2,-35.9,53.2,-47.7,30.1C-59.5,7.1,-65.1,-16.9,-56.1,-30.1C-47.1,-43.4,-23.6,-46,1.8,-47C27.2,-48.1,54.3,-47.6,66.1,-32.6Z"
                          transform="translate(100 100)"
                        />
                      </svg>
                    </div>
                  </div>
                  <div class="fbox-txt">
                    <h6 class="h6-lg">Adaptable</h6>
                    <p class="p-sm">
                      Customize your campaign for personal, community, or career
                      goals
                    </p>
                  </div>
                </div>
              </div>
              <div class="col">
                <div class="fbox-3 fb-3 r-12 wow fadeInUp">
                  <div class="fbox-ico ico-55">
                    <div class="shape-ico color--theme-2">
                      <span class="flaticon-dice"></span>
                      <svg
                        viewBox="0 0 200 200"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M66.1,-32.6C77.9,-17.7,74.4,11.6,60.8,35.7C47.2,59.7,23.6,78.5,2.8,76.9C-18,75.2,-35.9,53.2,-47.7,30.1C-59.5,7.1,-65.1,-16.9,-56.1,-30.1C-47.1,-43.4,-23.6,-46,1.8,-47C27.2,-48.1,54.3,-47.6,66.1,-32.6Z"
                          transform="translate(100 100)"
                        />
                      </svg>
                    </div>
                  </div>

                  <div class="fbox-txt">
                    <h6 class="h6-lg">Expressive</h6>
                    <p class="p-sm">
                      Engage supporters with photos, videos, and updates that
                      inspire.
                    </p>
                  </div>
                </div>
              </div>

              <div class="col">
                <div class="fbox-3 fb-4 r-12 wow fadeInUp">
                  <div class="fbox-ico ico-55">
                    <div class="shape-ico color--theme-2">
                      <span class="flaticon-scale"></span>
                      <svg
                        viewBox="0 0 200 200"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M66.1,-32.6C77.9,-17.7,74.4,11.6,60.8,35.7C47.2,59.7,23.6,78.5,2.8,76.9C-18,75.2,-35.9,53.2,-47.7,30.1C-59.5,7.1,-65.1,-16.9,-56.1,-30.1C-47.1,-43.4,-23.6,-46,1.8,-47C27.2,-48.1,54.3,-47.6,66.1,-32.6Z"
                          transform="translate(100 100)"
                        />
                      </svg>
                    </div>
                  </div>
                  <div class="fbox-txt">
                    <h6 class="h6-lg">Streamlined</h6>
                    <p class="p-sm">
                      Raise funds effectively with tools that simplify sharing
                      and engagement.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <hr class="divider" />

      <section class="pt-100 ct-01 content-section division">
        <div class="container">
          <div class="row d-flex align-items-center">
            <div class="col-md-6 order-last order-md-2">
              <div class="txt-block left-column wow animate__animated animate__fadeInRight">
                <h2 class="h2-md">Save Your Time & Effort with Ideateller</h2>
                <p>
                  Effortlessly manage your fundraising journey and engage
                  supporters with simple, powerful tools that save you time and
                  keep your focus on your goals.
                </p>
                <ul class="simple-list">
                  <li class="list-item">
                    <p>
                      Easily connect with backers and share your story,
                      simplifying your fundraising efforts and creating
                      meaningful engagement.
                    </p>
                  </li>

                  <li class="list-item">
                    <p class="mb-0">
                      Update your campaign with ease, track progress, and keep
                      supporters motivated with every milestone, all in one
                      place.
                    </p>
                  </li>
                </ul>
              </div>
            </div>
            <div class="col-md-6 order-first order-md-2">
              <div class="img-block right-column wow animate__animated animate__fadeInLeft">
                <img
                  class="img-fluid lt-img"
                  src="assets/images/img-09.png"
                  alt="content-image"
                />
                <img
                  class="img-fluid dt-img"
                  src="assets/images/img-09d.png"
                  alt="content-image"
                />
              </div>
            </div>
          </div>
        </div>
      </section>

      <section class="py-100 ct-01 content-section division">
        <div class="container">
          <div class="row d-flex align-items-center">
            <div class="col-md-6">
              <div class="img-block left-column wow animate__animated animate__fadeInRight">
                <img
                  class="img-fluid lt-img"
                  src="assets/images/img-03.png"
                  alt="content-image"
                />
                <img
                  class="img-fluid dt-img"
                  src="assets/images/img-03d.png"
                  alt="content-image"
                />
              </div>
            </div>

            <div class="col-md-6">
              <div class="txt-block right-column wow animate__animated animate__fadeInLeft">
                <h2 class="h2-md">Effortless Campaign Management</h2>
                <p>
                  Effortlessly manage your campaigns and engage supporters with
                  simple tools, achieving impactful results for your fundraising
                  journey.
                </p>

                <ul class="simple-list">
                  <li class="list-item">
                    <p>
                      Connect with backers easily, share your updates, and
                      inspire contributions toward your goal.
                    </p>
                  </li>

                  <li class="list-item">
                    <p class="mb-0">
                      Track progress, manage your campaign, and motivate
                      supporters with seamless, efficient tools that help you
                      succeed.
                    </p>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </section>

      <hr class="divider" />

      <section class="pt-100 bc-04 ws-wrapper content-section">
        <div class="container">
          <div class="bc-04-wrapper r-24">
            <div class="row d-flex align-items-center">
              <div class="col-md-5 col-lg-6 order-last order-md-2">
                <div class="txt-block left-column wow animate__animated animate__fadeInRight">
                  <h2 class="h2-md">Effortless Setup, Powerful Impact</h2>
                  <p>
                    Create and manage your fundraising campaigns with ease,
                    delivering beautiful results that inspire and engage
                    supporters.
                  </p>
                  <ul class="simple-list">
                    <li class="list-item">
                      <p>
                        Easily connect with backers, share your story, and
                        inspire contributions toward your goals.
                      </p>
                    </li>

                    <li class="list-item">
                      <p class="mb-0">
                        Track your progress, update your campaign, and motivate
                        supporters with efficient, simple tools.
                      </p>
                    </li>
                  </ul>
                </div>
              </div>
              <div class="col-md-7 col-lg-6 order-first order-md-2">
                <div class="bc-4-img video-preview right-column">
                  <a
                    class="video-popup2"
                    href="https://www.youtube.com/embed/7e90gBu4pas"
                  >
                    <div class="video-btn video-btn-xl bg--theme-2">
                      <div class="video-block-wrapper">
                        <span class="flaticon-play-button"></span>
                      </div>
                    </div>
                  </a>
                  <img
                    class="img-fluid r-24 block--shadow"
                    src="assets/images/img-17.jpg"
                    alt="content-image"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <hr class="divider" />

      <section class="pt-100 ct-03 content-section division">
        <div class="container">
          <div class="row d-flex align-items-center">
            <div class="col-md-6 order-last order-md-2">
              <div class="txt-block left-column wow animate__animated animate__fadeInRight">
                <h2 class="h2-md">Achieve More with Powerful Tools</h2>
                <p>
                  Effortlessly manage your campaigns and connect with
                  supporters, using intuitive tools that streamline your
                  fundraising journey.
                </p>
                <p>
                  Stay on track with easy-to-use features, share updates, and
                  engage backers, all while boosting your campaign’s success.
                </p>
              </div>
            </div>
            <div class="col-md-6 order-first order-md-2">
              <div class="img-block wow animate__animated animate__fadeInLeft">
                <img
                  class="img-fluid"
                  src="assets/images/tablet-02.png"
                  alt="content-image"
                />
              </div>
            </div>
          </div>
        </div>
      </section>

      <section id="faqs" class="py-100 faqs-1 faqs-section division">
        <div class="container">
          <div class="more-questions clearfix">
            <div class="more-questions-holder wow animate__animated animate__fadeInUp">
              <div class="more-questions-txt">
                <h6 class="h6-xl">Got a question? Let’s hear it!</h6>
                <p class="p-sm">
                  Contact us and we’ll get back to you as soon as we can.
                </p>
              </div>

              <div class="more-questions-btn">
                <a
                  href="contacts.html"
                  class="btn r-36 btn--tra-black hover--theme-2"
                >
                  Contact Us
                </a>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section id="download" class="banner-5 banner-section">
        <div class="container">
          <div class="banner-5-wrapper">
            <div class="banner-overlay bg--04 bg--fixed r-24">
              <div class="row d-flex align-items-center">
                <div class="col-md-6">
                  <div class="banner-5-txt left-column color--white wow animate__animated animate__fadeInUp animate__delay-1">
                    <h2 class="h2-md">Download the Ideateller App now!</h2>
                    <p class="p-md">
                      Start your fundraising journey today, connect with
                      supporters, and bring your ideas to life effortlessly.
                    </p>
                    <div class="stores-badge badge-img-lg">
                      <a href="#" class="store">
                        <img
                          class="googleplay"
                          src="assets/images/store_badges/appstore.png"
                          alt="appstore-badge"
                        />
                      </a>

                      <a href="#" class="store store-btn-2">
                        <img
                          class="googleplay"
                          src="assets/images/store_badges/googleplay.png"
                          alt="googleplay-badge"
                        />
                      </a>
                    </div>
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="banner-5-img right-column text-center wow animate__animated animate__fadeInUp animate__delay-2">
                    <img
                      class="img-fluid"
                      src="assets/images/img-18.png"
                      alt="banner-image"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <footer class="pt-100 footer-3 footer division">
        <div class="container">
          <div class="row">
            <div class="col-lg-3">
              <div class="footer-info">
                <img
                  class="footer-logo lt-img"
                  src="assets/images/app_logo.png"
                  alt="footer-logo"
                />
                <img
                  class="footer-logo dt-img"
                  src="assets/images/app_logo.png"
                  alt="footer-logo"
                />

                <div class="footer-qr-code r-16">
                  <img
                    class="img-fluid"
                    src="assets/images/qr-code.png"
                    alt="qr-code-image"
                  />
                </div>
              </div>
            </div>

            <div class="col-md-9 col-lg-6 col-xl-7">
              <div class="row footer-links clearfix">
                <div class="col-md-4">
                  <div class="fl-1">
                    <h6 class="d-title">Ideateller</h6>
                    <h6 class="m-title">Ideateller</h6>

                    <ul class="foo-links clearfix">
                      <li>
                        <p>
                          <a href="features.html">Why Ideateller?</a>
                        </p>
                      </li>
                      <li>
                        <p>
                          <a href="changelog.html">What’s New</a>
                        </p>
                      </li>
                      <li>
                        <p>
                          <a href="pricing-2.html">Pricing Plans</a>
                        </p>
                      </li>
                      <li>
                        <p>
                          <a href="download.html">Download</a>
                        </p>
                      </li>
                    </ul>
                  </div>
                </div>

                <div class="col-md-4">
                  <div class="fl-2">
                    <h6 class="d-title">Discover</h6>
                    <h6 class="m-title">Discover</h6>
                    <ul class="foo-links clearfix">
                      <li>
                        <p>
                          <a href="faqs.html">Help & Support</a>
                        </p>
                      </li>
                      <li>
                        <p>
                          <a href="contacts.html">Editor Help</a>
                        </p>
                      </li>
                    </ul>
                  </div>
                </div>

                <div class="col-md-4">
                  <div class="fl-3">
                    <h6 class="d-title">Company</h6>
                    <h6 class="m-title">Company</h6>
                    <ul class="foo-links clearfix">
                      <li>
                        <p>
                          <a href="about.html">About Us</a>
                        </p>
                      </li>
                      <li>
                        <p>
                          <a href="contacts.html">Contact Us</a>
                        </p>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>

            <div class="col-md-3 col-lg-3 col-xl-2">
              <div class="footer-connect">
                <h6>Connect With Us</h6>
                <ul class="footer-socials ico-25 clearfix">
                  <li>
                    <a href="#">
                      <span class="flaticon-facebook"></span>
                    </a>
                  </li>
                  <li>
                    <a href="#">
                      <span class="flaticon-twitter-1"></span>
                    </a>
                  </li>
                  <li>
                    <a href="#">
                      <span class="flaticon-github"></span>
                    </a>
                  </li>
                  <li>
                    <a href="#">
                      <span class="flaticon-youtube"></span>
                    </a>
                  </li>
                </ul>
              </div>
            </div>
          </div>

          <hr />
          <div class="bottom-footer">
            <div class="row row-cols-1 row-cols-md-2 d-flex align-items-center">
              <div class="col">
                <div class="footer-copyright">
                  <p class="p-sm">
                    &copy; 2024 Ideateller. <span>All Rights Reserved</span>
                  </p>
                </div>
              </div>

              <div class="col">
                <ul class="bottom-footer-list ico-10 text-end">
                  <li>
                    <p class="p-sm">
                      <a href="privacy.html">Privacy Policy</a>
                    </p>
                  </li>
                  <li class="footer-list-divider">
                    <p>
                      <span class="flaticon-minus-1"></span>
                    </p>
                  </li>
                  <li>
                    <p class="p-sm">
                      <a href="terms.html">Terms & Conditions</a>
                    </p>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </footer>
    </>
  );
}

export default App;
